import React from 'react';

function MyComponent() {
    return (
        <div>
            <h1>Hello, Component</h1>
        </div>
    );
}

export default MyComponent;